export const isObject = (item) => item && typeof item === 'object' && !Array.isArray(item);
export const isSSR = () => typeof document === 'undefined' || !document.createElement;
